import ReactOnRails from 'react-on-rails';

import Authentication from '../bundles/Authentication';

ReactOnRails.register({ Authentication });
